<template>
  <div class="card_offer">
    <img
      class="card_offer__image"
      :src="getImageServer() + url"
      v-if="url"
    >
    <img
      class="card_offer__image"
      src="@/assets/img/img-defecto.svg"
      v-else
    >
    <div class="card_offer__actions">
      <v-layout row wrap fill-height>
        <v-flex xs6>
          <div
            class="data_card__buttons--qr"
            style="border-radius: 10px"
          >
            <qr-icon></qr-icon>
          </div>
        </v-flex>
        <v-flex xs6 class="actions_buttons">
          <button
            class="actions_buttons__edit"
          >
              <edit-icon
                width="35"
                height="35"
              ></edit-icon>
            </button>
        </v-flex>
      </v-layout>
    </div>

    <div class="card_offer__body">
      <div class="card_offer__body--title">
        {{location.attributes.name}}
      </div>

      <div class="card_offer__body--subtitle">
        Descripción
      </div>
      <p class="card_offer__body--text" style="height: 140px">
        {{location.attributes.description}}
      </p>

      <div class="card_offer__body--subtitle">
        Dirección
      </div>
      <p
        class="card_offer__body--text"
        style="height: 60px; display: flex; align-items: center;"
      >
        {{location.attributes.address}}
      </p>

      <div class="card_offer__body--subtitle">
        Correo electrónico
      </div>
      <p class="card_offer__body--text" style="height: 40px">
        {{location.attributes.email}}
      </p>

      <div class="card_offer__body--subtitle">
        Tipo de locación
      </div>
      <p class="card_offer__body--text" style="height: 40px">
        {{location.attributes.location_type}}
      </p>

      <div class="card_offer__body--subtitle">
        Ciudad
      </div>
      <p class="card_offer__body--text" style="height: 40px">
        {{location.attributes.city}}
      </p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    location: Object,
    url: String
  },
}
</script>
<style scoped>
  .card_offer__body--title{
    height: 120px;
    background: #EFF3F7!important;
    border-radius: 10px;
    padding: 10px;
  }
  .card_offer__body--text{
    background: #EFF3F7 !important;
    border-radius: 10px;
    padding: 10px;
  }
  .classes_quantity{
    width: 40px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/PreviewLocation.vue